export default "/images/vendor/flag-icons/flags/4x3/gu.svg?cb24f455b6b06ce5325d710227725d45";